import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { PolicyService } from 'gw-capability-policy';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import metadata from './PolicyPrivacyDisclosure.metadata.json5';
import styles from './PolicyPrivacyDisclosure.module.scss';
import messages from './PolicyPrivacyDisclosure.messages';
import { Icon } from '@jutro/components';
import { useAuthentication } from '@xengage/gw-digital-auth-react';

/**
 * @param {*} props 
 * @returns 
 */
function PolicyPrivacyDisclosure(props) {
    const { showPrivacyDisclosure,updateShowPrivacyPreviousValue, showPrivacyPreviousValue, policyCommonDetails } = props;
    const privacyOptOut_TWIA = _.get(policyCommonDetails, 'privacyOptOut_TWIA')
    const translator = useContext(TranslatorContext);
    const [privacyOptOutVM, updatePrivacyOptOutVM] = useState();
    const [onCancelClick, setOnCancelClick] = useState(false);
    const [updatePrivacy, setUpdatePrivacy] = useState(false);
    const [onToggleChange, setOnToggleChange] = useState(false);
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();
    const { refreshData } = useDataRefresh();
    const additionalInterestData = useRef();
    let originalModel;
    let origModel;

    function privacyPolicyMessage() {
        return (
            <div>
                <span style={{ display: 'flex' }}>
                    <Icon id="icon" icon="gw-info" title="Info" color="#4074ce" />

                    <text style={{ paddingLeft: '6px' }}>{translator(messages.privacyDisclosureTextPart1)}</text>

                </span>
                <div>
                    <text style={{ paddingLeft: '23px' }}>{translator(messages.privacyDisclosureTextPart2)}</text>
                    <a href="https://www.twia.org/privacy-policy/" target="_blank" style={{ color: '#30A6DC', cursor: 'pointer', textDecorationLine: 'none' }}>Privacy Policy.</a>
                </div>

            </div>
        );
    }

    useEffect(() => {
        origModel = _.clone(privacyOptOut_TWIA);
        additionalInterestData.current = origModel

        const update = viewModelService.create(
            privacyOptOut_TWIA || {},
            'pc',
            'edge.capabilities.gateway.policy.dto.PrivacyOptOutDTO_TWIA'
        );

        updatePrivacyOptOutVM(update);

    }, []);


    const handleCancel = useCallback(
        () => {
            if (!_.isUndefined(origModel)) {
                privacyOptOut_TWIA.decision = origModel?.decision
            }

            updatePrivacyOptOutVM(privacyOptOut_TWIA);
            refreshData()
        }, []);

    const updatePrivacyDetails = useCallback(
        () => {
            privacyPolicyUpdate()
            setOnToggleChange(false)
            updateShowPrivacyPreviousValue(privacyOptOut_TWIA.decision)
        }, []);

    const privacyPolicyUpdate = () => {
        const policyNumber = _.get(policyCommonDetails, 'currentPeriodDetails.policyNumber')
        PolicyService.updatePrivacyPolicy(policyNumber, privacyOptOut_TWIA.decision, authHeader).then(() => {
            if (privacyOptOut_TWIA.decision) {
                setUpdatePrivacy(true);
                privacyOptOut_TWIA.recordedDate = new Date().toDateString();
            } else {
                setUpdatePrivacy(false);
            }
            origModel = _.clone(privacyOptOut_TWIA);
            updatePrivacyOptOutVM(privacyOptOut_TWIA)
            refreshData()
        })
    };

    const writeValue = useCallback(
        (value, path) => {
            if(!_.isUndefined(privacyOptOutVM.decision.value)) {
            updateShowPrivacyPreviousValue(privacyOptOutVM.decision.value);  
            } else {
                updateShowPrivacyPreviousValue(showPrivacyPreviousValue);
            }        
            _.set(privacyOptOutVM, path, value);
            setOnToggleChange(true);
            if (path === 'decision' && !value) {
                setUpdatePrivacy(false);
            }
            updatePrivacyOptOutVM(privacyOptOutVM);
            refreshData()
        }, [privacyOptOutVM, refreshData, updateShowPrivacyPreviousValue]
    );

    const overrideProps = {
        '@field': {},
        privacyPolicyMessage: {
            content: privacyPolicyMessage()
        },
        privacyDisclosureOptOutDate1: {
            visible: updatePrivacy || showPrivacyDisclosure &&
                _.get(privacyOptOut_TWIA, 'decision') === true && !onToggleChange
        },
        actionsContainer: {
            visible: onToggleChange
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            handleCancel,
            updatePrivacyDetails
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={privacyOptOut_TWIA}
            onValueChange={writeValue}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

export default PolicyPrivacyDisclosure;
